// CTSK-268 slice A — per-tab "Canonical: <file>.yaml ↗" link for the
// registry table surfaces (first tenant: the four Timeline Lane file
// tabs; second tenant since CTSK-280: the DSR page header, which
// replaced its CTSK-269 inline banner with this chip). Mirrors DSR's
// original "Canonical source of truth" banner treatment — mono code
// chip on the sunken surface — and adds the one thing the banner
// never had: when the
// registry pointer has resolved a documentId, the filename links to
// the Documents UI detail page in a NEW tab (plain <a target="_blank">,
// same pattern as the timeline tables' SourceCell). While the pointer
// is loading — or the file simply isn't uploaded into the bound
// container yet — the chip renders unlinked rather than pointing at a
// 404.

import { ExternalLink } from 'lucide-react';

export interface TabHeaderCanonicalLinkProps {
  /** Registry file path for the active tab, e.g. 'events.yaml'. */
  path: string;
  /** Underlying document id from the tool's registry pointer. When
   *  present the chip links to `/documents/<id>`; absent → plain text. */
  documentId?: string;
}

export function TabHeaderCanonicalLink({ path, documentId }: TabHeaderCanonicalLinkProps) {
  const chip = (
    <code style={{ fontFamily: 'var(--font-mono)', background: 'var(--surface-sunken)', padding: '1px 5px', borderRadius: 4 }}>
      {path}
    </code>
  );
  return (
    <span style={{ fontSize: 12, color: 'var(--text-muted)', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      Canonical:{' '}
      {documentId ? (
        <a
          href={`/documents/${documentId}`}
          target="_blank"
          rel="noopener noreferrer"
          title={`Open ${path} in the Documents UI (new tab)`}
          style={{ color: 'var(--accent-primary)', display: 'inline-flex', alignItems: 'center', gap: 4, textDecoration: 'none' }}
        >
          {chip}
          <ExternalLink size={11} aria-hidden="true" style={{ flexShrink: 0 }} />
        </a>
      ) : (
        chip
      )}
    </span>
  );
}
